import React, { useEffect } from 'react';
import '../styles/Disclaimer.css';

const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <section className="disclaimer-page">
      <div className="disclaimer-header">
        <h1 className="disclaimer-title">
          <span className="highlight">Disclaimer - </span>Mahadev
        </h1>
        <p className="disclaimer-update-date">Last Updated: 08/04/2025</p>
      </div>

      <div className="disclaimer-content">
        <p>
          Welcome to the Mahadev Book Official Disclaimer Page. By using our platform, you agree to the terms outlined here. Please read this carefully to understand your responsibilities and our limitations.
        </p>

        <p>
          <strong>1. Information Accuracy:</strong> While we aim for accuracy, we do not guarantee that all information on Mahadev Book is complete or error-free. Users are encouraged to verify content independently.
        </p>

        <p>
          <strong>2. Gambling Risks:</strong> Online betting involves risk. Mahadev Book Official is for entertainment purposes only. Users are fully responsible for any financial outcomes resulting from gambling.
        </p>

        <p>
          <strong>3. Platform Availability:</strong> We strive to ensure constant service availability but do not guarantee uninterrupted access. We reserve the right to suspend or modify services without notice.
        </p>

        <p>
          <strong>4. Third-Party Links:</strong> Our platform may contain links to third-party sites. We are not responsible for the content, reliability, or security of external websites. Proceed at your own discretion.
        </p>

        <p>
          <strong>5. Security Measures:</strong> While we implement measures to protect user data, the internet is not completely secure. Users should take their own precautions when using our platform.
        </p>

        <p>
          <strong>6. Updates to Disclaimer:</strong> We may revise this disclaimer from time to time. Continued use of the platform after updates implies your acceptance of the revised terms.
        </p>

        <p>
          <strong>7. Legal Compliance:</strong> Users are responsible for adhering to local laws regarding online gambling. We do not guarantee our services are legal in all jurisdictions.
        </p>

        <p>
          <strong>8. Contact:</strong> If you have questions regarding this disclaimer, contact us at{' '}
          <a href={ContactLink} target="_blank" rel="noopener noreferrer">+91 8888568888</a>.
        </p>

        <p>
          By using Mahadev Book Official, you acknowledge and accept the terms of this disclaimer.
        </p>

        <p style={{ color: "#DAA520" }}>
          Thank you for choosing Mahadev Book Official. Your trust and security are important to us.
        </p>
      </div>

      <div className="disclaimer-btn">
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          WhatsApp Us @ 8888988880
        </a>
      </div>
    </section>
  );
};

export default Disclaimer;
